<template>
  <div class="smart-mall">
    <el-container>
      <el-header class="flex-center" :style="{background: isTop?'#F2F2F2':'transparent'}">
        <div style="height:60px;max-width:1400px;width:100%"
             class="flex-space-between">
          <img @click="()=>{$router.push({path:'/smart_mall'})}" style="height:150px;cursor: pointer" src="../assets/logo.png"/>
          <div class="flex-space-between">
            <ul class="flex-center menus">
              <li v-for="(item,index) in menus"
                  @click="()=>{if($store.state.activeIndex!=index){$store.state.activeIndex=index;intent(item.path)}}"
                  class="title" :class="{'active':$store.state.activeIndex==index}">
                {{item.title}}
              </li>
            </ul>
            <p>
              <!--<span class="jump-demo">体验demo</span>-->
              <el-dropdown trigger="click" @command="avg=>{intent(avg)}">
                <span class="el-dropdown-link">
                  <em></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,index) in menus"
                                    :key="index"
                                    :command="item.path">{{item.title}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
          </div>
        </div>
      </el-header>
      <div class="el-main">
        <router-view/>
        <!--<div class="guide flex-col-center">
          <p style="font-size: 24px;color:#fff;margin-bottom:40px">经营客流&nbsp;&nbsp;&nbsp;提升坪效</p>
          <button class="jump-demo"
                  @click="()=>{dialogTableVisible = true}"
                  style="padding: 5px 10px;font-size:18px;background: rgb(255, 255, 255); color: #101010;">立即试用
          </button>
        </div> -->
        <div class="footer flex-col-center">
          <div class="foo-info flex-space-between">
            <div class="flex-center foo-logo">
              <img style="height:180px" src="../assets/logo.png"/>
              <span style="padding:10px">荣誉出品</span>
            </div>
            <!--<p class="foo-tel">-->
              <!--TEL:-->
              <!--<span>刘云华 13581530963</span>-->
              <!--<span>张宇阳 15982263340</span>-->
            <!--</p>-->
            <div class="flex-center foo-qr">
              <img src="../assets/us.jpg" style="width: 100px"/>
              <span style="margin-left:10px">关注公众号</span>
            </div>
          </div>
          <p class="letp" style="padding:0 0 0px 0;font-size: 14px">
            <span style="font-size: 14px">Copyright  All Rights Reserved. </span>
            <span style="font-size: 14px">四川迈希沃网络科技有限公司 版权所有</span>
          </p>
          <p class="letp" style="padding:0 0 10px 0;font-size: 14px">
            <span style="font-size: 14px" @click="toLinkBeiAn">备案号：蜀ICP备2024068492号</span>
          </p>
        </div>
      </div>
      <!--<el-footer>Footer</el-footer>-->
    </el-container>
    <el-dialog custom-class="dialog" :visible.sync="dialogTableVisible">
      <p style="font-size:16px;font-weight:bold;line-height: 2">留下您的联系方式</p>
      <p style="font-size:16px;font-weight:bold;line-height: 2">我们将会在2个工作日内与您联系</p>
      <el-form :model="ruleForm" label-position="left"
               :rules="rules"
               ref="ruleForm"
               style="margin-top:40px"
               label-width="60px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model.number="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="company">
          <el-input v-model="ruleForm.company"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="留言" prop="message">
          <el-input type="textarea" :rows="4" v-model="ruleForm.message"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    name: "forward",
    data() {
      return {
        isTop: false,
        menus: [
          {title: '公司介绍', path: '/smart_mall'},
          {title: '代理品牌', path: '/wk_product'},
          {title: '案例展示', path: '/wk_community'},
          {title: '联系我们', path: '/about'},],
        active: 0,
        dialogTableVisible:false,
        ruleForm: {
          name: '',
          phone: '',
          company: '',
          email:'',
          message:''
        },
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机', trigger: 'blur' },
            { type: 'number', message: '手机号必须为数字'}
          ],
          company: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          email:[
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          message:[
            { required: false, message: '请输入活动名称', trigger: 'blur' },
          ]
        }
      }
    },
    watch:{
      '$route':function(avg1,avg2){
        for(let i=0;i<this.menus.length;i++){
          if(this.$route.path.indexOf(this.menus[i].path)>=0){
            this.$store.state.activeIndex = i;
            break;
          }
        }
      }
    },
    mounted() {
      for(let i=0;i<this.menus.length;i++){
        if(this.$route.path.indexOf(this.menus[i].path)>=0){
          this.$store.state.activeIndex = i;
          break;
        }
      }
      let that = this;
      window.onscroll = function () {
        var t = document.documentElement.scrollTop || document.body.scrollTop;  //获取距离页面顶部的距离
        if (t > 600) {
          that.isTop = true;
        } else {
          that.isTop = false;
        }
      }
    },
    methods: {
      toLinkBeiAn(){
        window.open('http://beian.miit.gov.cn')
      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios({
              method: 'post',
              url:process.env.PUBLIC_URL+'/registerUser',
              data: qs.stringify({
                userName:that.ruleForm.name,
                phone:that.ruleForm.phone,
                inc:that.ruleForm.company,
                email:that.ruleForm.email,
                leaveMessage:that.ruleForm.message
              }),
              timeout: 30000,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }).then(
              (response) => {
                console.log(response);
                if(response.data&&response.data.success){
                  alert('提交成功')
                  this.dialogTableVisible = false;
                }else{
                  alert(response.data.message[0])
                }
              }
            )
          } else {
            return false;
          }
        });
      },
      intent(path) {
        this.$router.push({
          path
        })
      },
    }
  }
</script>

<style scoped>
  @import "../style.css";
  @import "./forward_pc.css";
  @import "./forward_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/forward.vue